export { default } from './GoalDetailsDucks'
export * from './GoalDetailsDucks'
